<template>
  <div class="wt-script">
    <div class="col-3 field-label">Transfer Script:</div>
    <div class="col-7 field-response" v-html="script">
    </div>
    <div class="col-2 field-error">
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'WarmTransferScript',
  props: ['transferScript', 'programName', 'campusName', 'offerName'],
  data () {
    return {
    }
  },
  methods: {
    mapText (text) {
      var customFields = [{ mappingText: '__program_name__', value: this.programName },
        { mappingText: '__campus_name__', value: this.campusName }
      ]
      customFields.forEach((f) => {
        text = text.replace(new RegExp(f.mappingText, 'g'), f.value)
      })

      return text
    }
  },
  computed: {
    script () {
      return this.transferScript ? this.mapText(this.transferScript) : ''
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer
    }),
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  }
}
</script>
